/** Safe number coercion for CMS-authored / SPD-response strings; treats empty/null and unparseable inputs as undefined. */
export const toNumber = (value: unknown): number | undefined => {
	if (value === undefined || value === null || value === '') return undefined;
	if (typeof value === 'number') return Number.isFinite(value) ? value : undefined;
	const stripped = String(value)
		.replace(/[^\d.,-]/g, '')
		.replace(',', '.');
	if (stripped === '' || !/\d/.test(stripped)) return undefined;
	const n = Number(stripped);
	return Number.isFinite(n) ? n : undefined;
};

/** Safe `new Date()` wrapper; returns undefined for unparseable / empty inputs. */
export const parseDateInput = (value: unknown): Date | undefined => {
	if (value === undefined || value === null || value === '') return undefined;
	const d = value instanceof Date ? value : new Date(String(value));
	return Number.isNaN(d.getTime()) ? undefined : d;
};
